'use client';

import { Radius } from '@ghosts-inc/design-system/constants';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const ListingCardSkeleton = () => {
  return (
    <Box width="100%" data-testid="listing-card-skeleton">
      <Box mb={1.5}>
        <Skeleton
          width="100%"
          sx={{ aspectRatio: '1', borderRadius: Radius.large }}
          variant="rectangular"
          height="inherit"
        />
      </Box>
      <Skeleton width="60%" />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
    </Box>
  );
};
